import { render, staticRenderFns } from "./mGuagePricingRuleDetail.vue?vue&type=template&id=d87c4034&"
import script from "./mGuagePricingRuleDetail.vue?vue&type=script&lang=js&"
export * from "./mGuagePricingRuleDetail.vue?vue&type=script&lang=js&"
import style0 from "./mGuagePricingRuleDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/mGuagePricingRuleDetail.vue
// module id = null
// module chunks = 